import { faArrowLeft, faSearch, faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon, Input, Row, Spin } from 'antd';
import { cloneDeep, differenceBy, filter } from "lodash";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { AddRemoveContent, ColumnHeader, ContentItem, UsersList } from '../../../components';
import { AmplitudeEventsUtils, DataUtils, RoleGroupUtils } from '../../../utilities';
var RoleUsers = forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var isMobileView = _a.isMobileView, authentication = _a.authentication, selectedRoleData = _a.selectedRoleData, updateRoleDetails = _a.updateRoleDetails, onload = _a.onload;
    var _e = useState({}), allUsers = _e[0], updateAllUsers = _e[1];
    var _f = useState(), filteredUsers = _f[0], updateFilteredUsers = _f[1];
    var _g = useState(), roleUserSearch = _g[0], updateRoleUserSearch = _g[1];
    var _h = useState(), filteredRoleUsers = _h[0], updateFilteredRoleUsers = _h[1];
    var _j = useState(undefined), selectedUsers = _j[0], updateSelectedUsers = _j[1];
    var _k = useState([]), selectedRoleUsers = _k[0], updateSelectedRoleUsers = _k[1];
    var _l = useState(false), userListLoading = _l[0], toggleUserListLoading = _l[1];
    var userList = (selectedRoleData === null || selectedRoleData === void 0 ? void 0 : selectedRoleData.users) || [];
    var activeRole = selectedRoleData;
    var adminRoleName = "Admin";
    var defaultRoleName = "Default";
    useEffect(function () {
        fetchUsersData();
    }, [authentication.selectedBrand]);
    useImperativeHandle(ref, function () { return ({
        resetStates: function () {
            resetAllStates();
        },
        fetchUsers: function () {
            fetchUsersData();
        }
    }); });
    var fetchUsersData = function () {
        toggleUserListLoading(true);
        DataUtils.user(authentication).getAll({ view: "all" }).then(function (data) { return updateAllUsers(data.data); })
            .finally(function () { return toggleUserListLoading(false); });
    };
    var filterUsersList = function (filterString, isUserNonAdmin) {
        if (Array.isArray(allUsers)) {
            var usersWithoutAlreadyPresentUsers = removeUnaccessibleUsers(isUserNonAdmin);
            var filteredArray = filter(usersWithoutAlreadyPresentUsers, function (obj) {
                var _a;
                return RoleGroupUtils.matchNameWithSearchString(filterString, obj) && (isUserNonAdmin ? ((_a = obj === null || obj === void 0 ? void 0 : obj.role) === null || _a === void 0 ? void 0 : _a.name) !== adminRoleName : true);
            });
            updateFilteredUsers(filteredArray);
        }
    };
    var removeUnaccessibleUsers = function (isUserNonAdmin) {
        if (Array.isArray(allUsers)) {
            var finalArray = [];
            var usersWithoutRoleUsers = finalArray = differenceBy(allUsers, cloneDeep(userList), "id");
            finalArray = usersWithoutRoleUsers;
            if (isUserNonAdmin) {
                var usersWithoutAdminUsers = filter(usersWithoutRoleUsers, function (ob) { var _a; return ((_a = ob === null || ob === void 0 ? void 0 : ob.role) === null || _a === void 0 ? void 0 : _a.name) !== adminRoleName; });
                finalArray = usersWithoutAdminUsers;
            }
            return finalArray;
        }
        return [];
    };
    var handleUserSelection = function (selectedUserList) {
        if ((selectedUserList === null || selectedUserList === void 0 ? void 0 : selectedUserList.length) > 0) {
            updateSelectedUsers(selectedUserList);
        }
        else
            updateSelectedUsers(undefined);
    };
    var handleAddUsers = function () {
        var formattedList = [];
        if (selectedUsers) {
            for (var _i = 0, _a = selectedUsers || []; _i < _a.length; _i++) {
                var user = _a[_i];
                var obj = {};
                obj.id = user;
                formattedList.push(obj);
            }
        }
        var finalList = userList.concat(formattedList);
        if (updateRoleDetails)
            updateRoleDetails(activeRole === null || activeRole === void 0 ? void 0 : activeRole.id, finalList, activeRole === null || activeRole === void 0 ? void 0 : activeRole.permissions, true);
        updateSelectedUsers(undefined);
        updateSelectedRoleUsers([]);
        AmplitudeEventsUtils.manageRoleAddUser(activeRole === null || activeRole === void 0 ? void 0 : activeRole.name, formattedList.length);
    };
    var handleRoleUserSelection = function (selectedUserList) {
        if ((selectedUserList === null || selectedUserList === void 0 ? void 0 : selectedUserList.length) > 0)
            updateSelectedRoleUsers(selectedUserList);
        else
            updateSelectedRoleUsers([]);
    };
    var handleDeleteUsers = function () {
        if (!((selectedRoleUsers === null || selectedRoleUsers === void 0 ? void 0 : selectedRoleUsers.length) > 0))
            return;
        var formattedList = [];
        for (var _i = 0, selectedRoleUsers_1 = selectedRoleUsers; _i < selectedRoleUsers_1.length; _i++) {
            var user = selectedRoleUsers_1[_i];
            var obj = {};
            obj.id = user;
            formattedList.push(obj);
        }
        var currentUsers = userList;
        var afterUsersDeletion = differenceBy(currentUsers, formattedList, "id");
        if (updateRoleDetails)
            updateRoleDetails(activeRole === null || activeRole === void 0 ? void 0 : activeRole.id, afterUsersDeletion, activeRole === null || activeRole === void 0 ? void 0 : activeRole.permissions, true);
        updateSelectedUsers(undefined);
        updateSelectedRoleUsers([]);
        AmplitudeEventsUtils.manageRoleRemoveUser(activeRole === null || activeRole === void 0 ? void 0 : activeRole.name, formattedList.length);
    };
    var onUserPopupClose = function () {
        resetAllStates();
    };
    var resetAllStates = function () {
        updateSelectedUsers(undefined);
        updateSelectedRoleUsers([]);
        updateFilteredUsers(undefined);
        updateFilteredRoleUsers(undefined);
        updateRoleUserSearch(undefined);
    };
    var handleRoleUserSearch = function (e) {
        updateRoleUserSearch(e.target.value);
        var filteredUsers = filterRoleUsers(e.target.value);
        updateFilteredRoleUsers(filteredUsers);
    };
    var filterRoleUsers = function (filterString) {
        var filteredArray = undefined;
        if (filterString && Array.isArray(userList)) {
            var thisRoleUsers = cloneDeep(userList);
            filteredArray = filter(thisRoleUsers, function (obj) {
                return RoleGroupUtils.matchNameWithSearchString(filterString, obj);
            });
        }
        return filteredArray;
    };
    var removeAlreadyPresentUsers = function (isUserNonAdmin) {
        var usersWithoutAlreadyPresentUsers = removeUnaccessibleUsers(isUserNonAdmin);
        return usersWithoutAlreadyPresentUsers;
    };
    var isUserAnAdmin = ((_c = (_b = onload === null || onload === void 0 ? void 0 : onload.user) === null || _b === void 0 ? void 0 : _b.role) === null || _c === void 0 ? void 0 : _c.name) === adminRoleName;
    var isUserSuperAdmin = onload === null || onload === void 0 ? void 0 : onload.isSuperAdmin;
    var isUserNotAnAdmin = !(isUserAnAdmin || isUserSuperAdmin);
    var usersListToView = Array.isArray(filteredUsers) ? filteredUsers : removeAlreadyPresentUsers(isUserNotAnAdmin);
    var usersWithStatus = RoleGroupUtils.filterUsersByStatus(usersListToView, onload);
    var roleUsersToView = filteredRoleUsers && Array.isArray(filteredRoleUsers) ? filteredRoleUsers : cloneDeep(userList);
    var isDefaultRoleSelected = (activeRole === null || activeRole === void 0 ? void 0 : activeRole.name) === defaultRoleName;
    var isAdminRoleSelected = (activeRole === null || activeRole === void 0 ? void 0 : activeRole.name) === adminRoleName;
    var noRoleUsersSelected = !((selectedRoleUsers === null || selectedRoleUsers === void 0 ? void 0 : selectedRoleUsers.length) > 0);
    var shouldDisableAdd = (isAdminRoleSelected && isUserNotAnAdmin) || !(activeRole === null || activeRole === void 0 ? void 0 : activeRole.permissions);
    var shouldDisableDelete = isDefaultRoleSelected || (isAdminRoleSelected && isUserNotAnAdmin) || noRoleUsersSelected || !(activeRole === null || activeRole === void 0 ? void 0 : activeRole.permissions);
    return React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(ColumnHeader, { icon: faUser, label: "Users", isMobileView: isMobileView })),
        React.createElement(Row, { style: { minHeight: "110px" } },
            React.createElement(AddRemoveContent, { addContentNode: {
                    node: React.createElement(ContentItem, { disabled: shouldDisableAdd, description: "Move users to this role" }),
                    callback: handleAddUsers,
                    disabled: shouldDisableAdd
                }, deleteContentNode: {
                    node: React.createElement(ContentItem, { disabled: shouldDisableDelete, color: "pink", iconName: faArrowLeft, description: "Move selected users to default role" }),
                    callback: handleDeleteUsers,
                    disabled: shouldDisableDelete
                }, containerType: "users", isRolePage: true, userData: React.createElement(Spin, { indicator: React.createElement(Icon, { type: "loading", spin: true, style: { fontSize: "1.5rem" } }), spinning: userListLoading },
                    React.createElement(UsersList, { userList: !userListLoading ? usersWithStatus.activeUsers || [] : [], handleUserSelection: handleUserSelection, selectedUsers: selectedUsers || [], entityType: "role", userPopup: true })), filterUsersList: function (filterString) { return filterUsersList(filterString, isUserNotAnAdmin); }, selectedUsers: selectedUsers || [], handleUserSelection: handleUserSelection, onUserPopupClose: onUserPopupClose })),
        React.createElement(Row, null,
            (userList === null || userList === void 0 ? void 0 : userList.length) > 0 && React.createElement("div", { style: { padding: "0 20px 20px 5px" } },
                React.createElement(Input, { prefix: React.createElement(FontAwesomeIcon, { className: "color-gray-5", icon: faSearch }), placeholder: "Search", value: roleUserSearch, onChange: function (e) { return handleRoleUserSearch(e); }, allowClear: true })),
            React.createElement(UsersList, { isViewOnly: isDefaultRoleSelected || (isAdminRoleSelected && isUserNotAnAdmin), entityType: "role", userList: roleUsersToView, loggedUserId: (_d = onload === null || onload === void 0 ? void 0 : onload.user) === null || _d === void 0 ? void 0 : _d.id, handleUserSelection: handleRoleUserSelection, selectedUsers: selectedRoleUsers })));
});
export default RoleUsers;
//# sourceMappingURL=index.js.map